"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _colors = require("@mui/material/colors");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/** this generates a predictible array of colors
 * to display when showing bar charts on polls but could be
 * easily used in any other component scenario that has a list
 * that in need of visuals e.g. list of questions submissions.
 */
var SmartColor = exports["default"] = /*#__PURE__*/function () {
  function SmartColor() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, SmartColor);
    this.colors = config.colors || [_colors.red['500'], _colors.pink['500'], _colors.purple['500'], _colors.deepPurple['500'], _colors.indigo['500'], _colors.blue['500'], _colors.lightBlue['500'], _colors.cyan['500'], _colors.teal['500'], _colors.green['500'], _colors.lightGreen['500'], _colors.lime['500'], _colors.amber['500'], _colors.orange['500'], _colors.brown['500'], _colors.blueGrey['500']];
  }
  return _createClass(SmartColor, [{
    key: "getSmartColor",
    value: function getSmartColor(i) {
      return this.colors[i % this.colors.length];
    }
  }]);
}();